//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { LanguageDisplayItem } from './LanguageDisplayItem';
import { TeacherNameDisplayItem } from './TeacherNameDisplayItem';

export class WebsiteRenderContextTeacherNameDisplayItem extends TeacherNameDisplayItem {
    SpokenLanguages: LanguageDisplayItem[] = [];

    constructor(initializer?: Partial<WebsiteRenderContextTeacherNameDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "WebsiteRenderContextTeacherNameDisplayItem";
}
